module.exports = __webpack_public_path__ + "img/icon-exchange.d6e3f859.svg";